import { Component, OnInit, effect, inject } from '@angular/core';
import { PressReleaseService } from './servicea/press-release.service';
import { SharedSignalsService } from '../common/services/shared-signals.service';

@Component({
  selector: 'taly-press-release',
  templateUrl: './press-release.component.html',
  styleUrls: ['./press-release.component.scss']
})
export class PressReleaseComponent implements OnInit {
  transferSignal = inject(SharedSignalsService);
  pressReleaseList: any;
  textDirection: string;
  
  constructor(private pressReleaseService: PressReleaseService) {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
    });
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.getAllPressReleaseList()

  }
  getAllPressReleaseList() {
    this.pressReleaseService.getAllPressRelease().subscribe((res) => {
      this.pressReleaseList = res;
    })
  }

}
